import { render, staticRenderFns } from "./EditRound.vue?vue&type=template&id=f4c19d7c&scoped=true"
import script from "./EditRound.vue?vue&type=script&lang=js"
export * from "./EditRound.vue?vue&type=script&lang=js"
import style0 from "./EditRound.vue?vue&type=style&index=0&id=f4c19d7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c19d7c",
  null
  
)

export default component.exports